export default __webpack_public_path__ + "static/media/19.9857e776.png";